"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apply_builtin = exports.getVariable = exports.declareIdentifier = exports.setValueToIdentifier = exports.checkNumberOfArguments = exports.isNumber = void 0;
const constants_1 = require("../constants");
const errors = require("../errors/errors");
const tags_1 = require("../memory/tags");
const defaults_1 = require("./defaults");
const environment_1 = require("./environment");
const errors_1 = require("./errors");
const isNumber = (v) => typeof v === 'number';
exports.isNumber = isNumber;
function checkNumberOfArguments(context, command, lambda) {
    if (lambda.type == 'Closure_i') {
        if (lambda.parameters == undefined) {
            return (0, errors_1.handleRuntimeError)(context, new errors.CallingNonFunctionValue(undefined, command));
        }
        if (lambda.parameters.length != command.arity) {
            return (0, errors_1.handleRuntimeError)(context, new errors.InvalidNumberOfArguments(command, lambda.parameters.length, command.arity));
        }
        return undefined;
    }
    else if (lambda.type == 'Builtin') {
        if (lambda.hasVarArgs && command.arity - lambda.arity >= 0) {
            return undefined;
        }
        else if (command.arity != lambda.arity) {
            return (0, errors_1.handleRuntimeError)(context, new errors.InvalidNumberOfArguments(command, lambda.arity, command.arity));
        }
        return undefined;
    }
    else {
        return (0, errors_1.handleRuntimeError)(context, new errors.CallingNonFunctionValue(undefined, command));
    }
}
exports.checkNumberOfArguments = checkNumberOfArguments;
const setValueToIdentifier = (command, context, name, value) => {
    let environment = (0, environment_1.currentEnvironment)(context);
    while (environment) {
        if (environment.head.hasOwnProperty(name)) {
            environment.head[name] = value;
            return value;
        }
        else {
            environment = environment.tail;
        }
    }
    return (0, errors_1.handleRuntimeError)(context, new errors.UndefinedVariable(name, context.runtime.nodes[0]));
};
exports.setValueToIdentifier = setValueToIdentifier;
function declareIdentifier(context, name, node, addr) {
    const environment = (0, environment_1.currentEnvironment)(context);
    if (environment.head.hasOwnProperty(name)) {
        return (0, errors_1.handleRuntimeError)(context, new errors.ExceptionError(new Error('Redeclared'), node.loc));
    }
    environment.head[name] = addr;
    return environment;
}
exports.declareIdentifier = declareIdentifier;
function getVariable(context, name) {
    let environment = (0, environment_1.currentEnvironment)(context);
    while (environment) {
        if (environment.head.hasOwnProperty(name)) {
            if (environment.head[name] === constants_1.DECLARED_BUT_NOT_YET_ASSIGNED) {
                return (0, errors_1.handleRuntimeError)(context, new errors.UnassignedVariable(name, context.runtime.nodes[0]));
            }
            else {
                return environment.head[name];
            }
        }
        else {
            environment = environment.tail;
        }
    }
    return (0, errors_1.handleRuntimeError)(context, new errors.UndefinedVariable(name, context.runtime.nodes[0]));
}
exports.getVariable = getVariable;
const apply_builtin = (builtin_symbol, args, memory) => {
    let resolvedArgs = [];
    for (const arg of args) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars, prefer-const
        let [memType, addr] = arg;
        let [type, value] = memory.mem_read(addr);
        if (memType == tags_1.TAGS.char_pointer_tag) {
            let s = '';
            s += String.fromCharCode(value);
            addr += memory.word_size;
            while (memory.mem_read(addr)[1] !== 0 &&
                tags_1.TAG_TO_TYPE[memory.mem_read(addr)[0]] === constants_1.CHAR_TYPE) {
                ;
                [type, value] = memory.mem_read(addr);
                s += String.fromCharCode(value);
                addr += memory.word_size;
            }
            resolvedArgs.push(s);
        }
        else if (tags_1.TAG_TO_TYPE[memType] == constants_1.CHAR_TYPE) {
            resolvedArgs.push(String.fromCharCode(addr));
        }
        else {
            resolvedArgs.push(addr);
        }
    }
    const nullIndex = resolvedArgs.findIndex(v => v === '\0');
    if (nullIndex != -1) {
        const stringInput = resolvedArgs.slice(nullIndex + 1).join('');
        const parameters = resolvedArgs.slice(0, nullIndex);
        resolvedArgs = [...parameters, stringInput];
    }
    resolvedArgs.reverse();
    return defaults_1.builtin_functions[builtin_symbol].apply(memory, ...resolvedArgs);
};
exports.apply_builtin = apply_builtin;
//# sourceMappingURL=utils.js.map